import styled from 'styled-components';

const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 140px;
  height: 50px;
  margin: 0 10px 7px 29px;
  padding-top: 7px;
`;
const SocialMediaIcon = styled.div`
  position: relative;
`;

const Header = styled.div`
  max-width: 260px;
  margin-top: 20px;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  color: #818da8;
  margin-left: 30px;
  margin-right: 30px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-tap-highlight-color: transparent;
  border-bottom: 1px solid #e8ebf2;
  padding-bottom: 10px;
`;

export { MainContainer, Header, SocialMediaIcon, Container };
